import { Flex, Modal, theme } from "antd";

function InventorySummaryModal({ title, value, icon, visible, onClose }) {
    const { token } = theme.useToken();

    return (
        <Modal width={400} title={<p style={{ fontSize: token.fontSizeHeading4, textAlign: "center" }}>Detail Inventory</p>} open={visible} onCancel={onClose} maskClosable={false} footer={null}>
            <div>
                <Flex gap={4}>
                    <span style={{ fontSize: token.fontSizeHeading5 }}>{icon}</span>
                    <span style={{ fontSize: token.fontSizeHeading5 }}>{title}</span>
                </Flex>
                <p style={{ fontSize: token.fontSizeHeading5 }}>{value}</p>
            </div>
        </Modal>
    );
}

export default InventorySummaryModal;
